<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="main-box">
      <img src="../assets/img-1.png" class="img-1">
      <p class="title">Latest release</p>
      <div class="list-box">
        <div class="item">
          <div class="img item-img-1"></div>
          <div>Chick laundry</div>
          <p>Puzzle casual games</p>
        </div>
        <div class="item">
          <div class="img item-img-2"></div>
          <div>Snake</div>
          <p>Team casual games</p>
        </div>
        <div class="item">
          <div class="img item-img-3"></div>
          <div>battle kingdom</div>
          <p>Board business games</p>
        </div>
        <div class="item">
          <div class="img item-img-4"></div>
          <div>Goose and duck killing</div>
          <p>Team puzzle game</p>
        </div>
        <div class="item">
          <div class="img item-img-5"></div>
          <div>I am a great detective</div>
          <p>Puzzle game</p>
        </div>
        <div class="item">
          <div class="img item-img-6"></div>
          <div>who is the murderer</div>
          <p>Crime Solving Game</p>
        </div>
      </div>

      <p class="title">Online experience</p>
      <div class="game-list">
        <div class="game-item">
          <img src="../assets/game-1.png" alt="">
          <div class="labe-value">
            <div>Build a house</div>
            <p>FunFiesta</p>
          </div>
          <div class="labe-value">
            <div>Release Date</div>
            <p>2024/1/8</p>
          </div>
          <div class="labe-value">
            <div>Number of players</div>
            <p>10w+</p>
          </div>
          <div class="labe-value">
            <div>The current situation</div>
            <p>Play online</p>
          </div>
          <a class="pay" href="/games/towe"> Play</a>
        </div>

        <div class="game-item">
          <img src="../assets/game-2.png" alt="">
          <div class="labe-value">
            <div>Balloons</div>
            <p>FunFiesta</p>
          </div>
          <div class="labe-value">
            <div>Release Date</div>
            <p>2023/12/16</p>
          </div>
          <div class="labe-value">
            <div>Number of players</div>
            <p>11w+</p>
          </div>
          <div class="labe-value">
            <div>The current situation</div>
            <p>Play online</p>
          </div>
          <a class="pay" href="/games/qqppp"> Play</a>
        </div>

        <div class="game-item">
          <img src="../assets/game-3.png" alt="">
          <div class="labe-value">
            <div>Crashed plane</div>
            <p>FunFiesta</p>
          </div>
          <div class="labe-value">
            <div>Release Date</div>
            <p>2024/2/14</p>
          </div>
          <div class="labe-value">
            <div>Number of players</div>
            <p>2w+</p>
          </div>
          <div class="labe-value">
            <div>The current situation</div>
            <p>Play online</p>
          </div>
          <a class="pay" href="/games/djz"> Play</a>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
};
</script>

<style lang="less" scoped>
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.main-box {
  width: 1068px;
  min-height: 1666px;
  flex-shrink: 0;
  border-radius: 40px;
  opacity: 0.8;
  background: #2F97FF;
  margin-top: 50px;
  padding: 64px 55px;

  .img-1 {
    width: 1068px;
    border-radius: 20px;
  }

  .title {
    color: #FFF;
    font-size: 40px;
    font-weight: 700;
    text-transform: capitalize;
    margin-top: 50px;
  }

  .list-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 40px;

    .item {
      width: 290px;
      min-height: 285px;
      border-radius: 20px;
      background-color: #8fbbe7;
      padding: 20px;
      margin-bottom: 30px;

      .img {
        width: 290px;
        height: 200px;
        flex-shrink: 0;
        border-radius: 10px;
      }

      .item-img-1 {
        background: url(../assets/img-2.png) lightgray 50% / cover no-repeat;
      }

      .item-img-2 {
        background: url(../assets/img-3.png) lightgray 50% / cover no-repeat;
      }

      .item-img-3 {
        background: url(../assets/img-4.png) lightgray 50% / cover no-repeat;
      }

      .item-img-4 {
        background: url(../assets/img-5.png) lightgray 50% / cover no-repeat;
      }

      .item-img-5 {
        background: url(../assets/img-6.png) lightgray 50% / cover no-repeat;
      }

      .item-img-6 {
        background: url(../assets/img-7.png) lightgray 50% / cover no-repeat;
      }

      div {
        color: #FFF;
        font-size: 24px;
        font-weight: 700;
        text-transform: capitalize;
        margin-top: 20px;
      }

      p {
        color: #FFF;
        font-size: 18px;
        font-weight: 300;
        margin-top: 8px;
      }
    }
  }

  .game-list {
    margin-top: 40px;

    .game-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 40px;

      img {
        width: 70px;
        height: 70px;
        border-radius: 10px;
        margin-right: 20px;
      }

      .labe-value {
        width: 300px;

        div {
          color: #FFF;
          font-size: 24px;
          font-weight: 700;
        }

        p {
          color: #FFF;
          font-size: 18px;
          font-weight: 300;
          margin-top: 8px;
        }
      }

      .pay {
        width: 215px;
        height: 44px;
        line-height: 44px;
        border-radius: 22px;
        border: 1px solid #FFF;
        color: #FFF;
        font-size: 14px;
        font-weight: 600;
        text-align: center;
        cursor: pointer;
      }
    }
  }

}
</style>
